export default {
    state: {
        typeList: {}
    },
    mutations: {
        setTypeList(state, data) {
            state.typeList[data.type] = data.data
        }
    }
};
